import React from 'react'
import Page from 'layouts/Page'
import Masthead, { MastheadOverlap } from 'layouts/Masthead'
import Container from 'layouts/Container'
import Box, { BoxSection } from 'layouts/Box'
import { Node, md } from 'djedi-react'
import theTeam from 'assets/team.jpg'
import styles from './AboutUs.css'

export default () => (
  <Page title="Om oss" plain>
    <Masthead overlap plain>
      <Container size="medium">
        <h1>
          <Node uri="about/heading">
            Om oss - Framtidens Fritidsaktiviteter
          </Node>
        </h1>
      </Container>
    </Masthead>
    <MastheadOverlap>
      <Container size="medium">
        <Box>
          <BoxSection className={styles.marginTop}>
            <img src={theTeam} alt="" />
            <Node uri="about/text.md">
              {md`
                friendtivity grundades av trebarnsmammorna Lena
                Wijkström, VD och Louise Wachtmeister, ordförande,
                med insikten att utbudet av fritidsaktiviteter för
                barn borde kunna breddas och göras mer flexibla,
                lättillgängliga och prisvärda.

                friendtivity har som mål att aktiviteterna ska
                bidra till att fler barn och unga i Sverige får
                möjlighet att ha en rolig och meningsfull fritid.
                Tillsammans med gamla eller nya kompisar, ska varje
                barn kunna hitta sitt sammanhang.

                Lena och Louise har en delad passion för idrott.
                Båda har tävlat på elitnivå i tennis respektive
                löpning samt har en lång bakgrund i svenskt
                föreningsliv. Samtidigt har båda själva och genom
                sina barn saknat alternativ till idrott som
                fritidsaktivitet. Lena och Louise delar värderingen
                om att det viktiga är inte vad man gör utan att man
                gör något som man tycker är roligt och därigenom
                utvecklas och får möjlighet att hitta just sitt
                sammanhang genom den lilla gruppen.
              `}
            </Node>
          </BoxSection>
        </Box>
      </Container>
    </MastheadOverlap>
  </Page>
)



// WEBPACK FOOTER //
// ../source/static/AboutUs.js